import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ImageFile } from '../../../../../../shared/_data-model/image-file';
import { UtilService } from '../../../../../../shared/_services/util.service';
import { StatusModalComponent } from '../../../../../modals/status-modal/status-modal.component';
import { Subject, Subscription } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ValidationService } from '../../../../../../shared/_services/validation.service';
import { HotelManagementService } from '../../../../../../shared/_services/hotel-management.service';
import { LoyaltyService } from '../../../../../../shared/_services/loyalty.service';
import { environment } from '../../../../../../../environments/environment';
import { GetJsonService } from '../../../../../../shared/_services/get-json.service';


@Component({
  selector: 'app-landing-page-hero-banner',
  templateUrl: './landing-page-hero-banner.component.html',
  styleUrls: ['./landing-page-hero-banner.component.scss']
})
export class LandingPageHeroBannerComponent implements OnInit {
  spanish: any;
  english: any;
  successMsg: string;
  isDirtyEn: boolean = false;
  isDirtyEs: boolean = false;
  brand: any;
  environment = environment;
  birthdayBannerEn: FormGroup;
  birthdayBannerEs: FormGroup;
  pastBannerEn: FormGroup;
  pastBannerEs: FormGroup;
  upcomingBannerEs: FormGroup;
  upcomingBannerEn: FormGroup;
  defaultBannerEs: FormGroup;
  defaultBannerEn: FormGroup;
  defaultBannerNonMemberEs: FormGroup;
  defaultBannerNonMemberEn: FormGroup;
  errorUpload: boolean;
  imageUrl: any;
  errorDetails: any;
  imageFile: any;
  imageFile_logo: ImageFile = new ImageFile;
  logoError: any;
  statusModal: BsModalRef;
  private subscription: Subscription;
  items: any[] = ['Member', 'Customer'];
  formMapping: any = {
    'default': 'initDefaultBannerForm',
    'default non-member': 'initDefaultBannerNonMemberForm',
    'upcoming': 'initUpcomingBannerForm',
    'past visit': 'initPastBannerForm',
    'birthday': 'initBirthdayBannerForm'
  }
  private unsubscribe: Subject<void> = new Subject<void>();
  @ViewChild('uploadDefaultBannerEn') uploadDefaultBannerEn: any;
  @ViewChild('uploadDefaultBannerNonMemberEn') uploadDefaultBannerNonMemberEn: any;
  @ViewChild('uploadDefaultBannerEs') uploadDefaultBannerEs: any;
  @ViewChild('uploadDefaultBannerNonMemberEs') uploadDefaultBannerNonMemberEs: any;
  @ViewChild('uploadbirthdayBannerEn') uploadbirthdayBannerEn: any;
  @ViewChild('uploadbirthdayBannerEs') uploadbirthdayBannerEs: any;
  logoSizeError: any;
  constructor(
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    public translate: TranslateService,
    private validationService: ValidationService,
    private utilService: UtilService,
    private loyaltyService: LoyaltyService,
    public modalService: BsModalService,
    private hotelManagementService: HotelManagementService,
    private getJsonService:GetJsonService
  ) {
    // let user = JSON.parse(localStorage.getItem('loggedInUser'));
    // translate.setDefaultLang('en');
    // translate.use('en');
    this.modalService.onHide
      .takeUntil(this.unsubscribe).subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.type == "hca-wizard") {
            if (this.statusModal.content.srcObject.action == "action1") {
              // Resets the form data
            }
          }
          if (this.statusModal.content.srcObject.type == "hca-image") {
            if (this.statusModal.content.srcObject.action == "action1") {
              const form = this.statusModal.content.srcObject.form;
              this.removeImage(form);
            }
          }
          if (this.statusModal.content.srcObject.type == "hca-hero-banner") {
            if (this.statusModal.content.srcObject.action == "action1") {
              if (this.isDirtyEn == true) {
                this.isDirtyEn = false;
                setTimeout(() => {
                  this.getHeroBannerData(this.brand.brandId);
                  let element = document.getElementById("Es");
                  element.click();
                }, 50);
              }
              if (this.isDirtyEs == true) {
                this.isDirtyEs = false;
                setTimeout(() => {
                  this.getHeroBannerData(this.brand.brandId);
                  let element = document.getElementById("En");
                  element.click();
                }, 50);
              }
            }
          }
        }
      })
  }

  getHeroBannerData(brandId) {
    this.loyaltyService.getHeroBannerData(brandId).subscribe(res => {
      console.log('=========== header and footer res ========', res);
      if (res.error == 0) {
        if (res.responseObj && res.responseObj.length) {

          console.log('==========res.responseObj==========', )
          res.responseObj.forEach(data => {
            Object.keys(this.formMapping).forEach(type => {
              if (data.heroBannerType == type) {
                if (data.languageId == 1) {
                  this[this.formMapping[type]](data, data.languageId, data.buttonActionType);
                }
                if(data.languageId == 2) {
                  this[this.formMapping[type]](data, data.languageId, data.buttonActionType);
                }
              }
            })
          })
        } else {
          this.initForm();
        }
      }
    }, err => {
      console.error('Error fetching loyalty website header and footer data', err);
    })

  }


  getImgStyle(id, imgSrc) {
    return `${environment.BASE_IMAGE_API}/images/herobanner/${id}/${imgSrc}`;
  }

  saveForm() {
    let formData = {
      brandId: this.hotelManagementService.getSelectedBrand().brandId,
      heroBannerTypeDataTos: [
        this.defaultBannerEn.value, this.defaultBannerEs.value,
        this.defaultBannerNonMemberEn.value, this.defaultBannerNonMemberEs.value,
        this.upcomingBannerEn.value, this.upcomingBannerEs.value,
        this.pastBannerEn.value, this.pastBannerEs.value,
        this.birthdayBannerEn.value, this.birthdayBannerEs.value
      ]
    }
    this.loyaltyService.saveLoyaltyWebsite(formData).subscribe(res => {
      console.log(res);
      this.isDirtyEn=false;
      this.isDirtyEs=false;
      this.successMsg = 'Saved successfully';
      setTimeout(() => {
        this.successMsg = '';
      }, 1000);
    }, err => {
      this.errorDetails = err.message ? err.message : 'Error while saving';
      setTimeout(() => {
        this.errorDetails = '';
      }, 1000);
      console.error('Error Saving ', err.message);
    })
    console.log('======== defaultBannerEn ==========', this.defaultBannerEn.value);
  }

  fileChanged(event: any, control?, uploadType?) {
    let image = URL.createObjectURL(event.target.files[0]);
    console.log('image:::++', image);
    let fileList: FileList = event.target.files;
    this.imageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(image);
    this.imageFile = event.target.files[0];
    this.removeImage(control);
    this.errorUpload = false;
    if (fileList.length > 0 && (this.imageFile.type === 'image/png' || this.imageFile.type === 'image/jpg' || this.imageFile.type === 'image/jpeg')) {
      if(this.imageFile.size >= 1048576) {
        this[control].get('backgroundImageSizeError').patchValue(true);
        setTimeout(() => {
          this[control].get('backgroundImageSizeError').patchValue(false);
          this[control].get('backgroundImageError').patchValue(false);
        }, 1500);
        this.errorUpload = true;
        this.resetFileInput(uploadType);  
      } else {
        this[control].get('backgroundImageError').patchValue(false);
        this[control].get('backgroundImageSizeError').patchValue(false);
        this.errorUpload = false;
      }
    } else {
      this[control].get('backgroundImageError').patchValue(true);
      setTimeout(() => {
        this[control].get('backgroundImageSizeError').patchValue(false);
        this[control].get('backgroundImageError').patchValue(false);
      }, 1500);
      this.resetFileInput(uploadType);
      this.errorUpload = true;
      console.log('Please upload Images only');
    }
    let formData: any = new FormData();
    if (this.imageFile) {
      let fileName = this.imageFile.name ? this.utilService.getModifiedString(this.imageFile.name) : this.utilService.getRandomInt(0, 1000000);
      formData.append('image', this.imageFile, fileName);
    } else {
      var file = new Blob([], { type: 'image/jpg' });
      formData.append('image', file, null);
    }
    if (!this.errorUpload) {
      this.utilService.uploadFile(formData).subscribe((res) => {
        if (res.error == 0) {
          this[control].get('backgroundImage').patchValue(res.responseObj);
          this[control].get('backgroundImageUrl').patchValue(this.imageUrl);
        }
        this.resetFileInput(uploadType);
      }, error => {
        this[control].get('backgroundImageError').patchValue(error.message);
        this.errorUpload = error.message;
        this.resetFileInput(uploadType);
        console.log('========res ===========', error);
      })
    }


  }

  removeImage(control) {
    this[control].get('backgroundImage').patchValue(null, { emitEvent: false });
    this[control].get('backgroundImageUrl').patchValue(null, { emitEvent: false });
    this[control].get('backgroundImageError').patchValue(false, { emitEvent: false });
    this[control].get('backgroundImageSizeError').patchValue(false, { emitEvent: false });
  }

  resetFileInput(element?) {
    console.log(this[element].nativeElement.files);
    this[element].nativeElement.value = "";
    console.log(this[element].nativeElement.files);
  }


  initBannerForm(data?, bannerType?, langId?, buttonType?) {
    return this.fb.group({
      id: [data ? data.id : null],
      backgroundImage: [data ? data.backgroundImage : null],
      backgroundImageUrl: [data ? data.backgroundImageUrl : null],
      backgroundImageError: [false],
      backgroundImageSizeError: [false],
      buttonActionType: [buttonType ? buttonType : 'Book Now'],
      buttonText: [data ? data.buttonText : null],
      content: [data ? data.content : null],
      externalUrl: [data ? data.externalUrl : null],
      heading: [data ? data.heading : null],
      heroBannerType: [bannerType ? bannerType : ''],
      languageId: [langId ? langId : ''],
      showAfter: [data ? data.showAfter : null],
      showBefore: [data ? data.showBefore : null],
      showForDays: [data ? data.showForDays : null],
      messageText: [data ? data.messageText : null],
      subHeading: [data ? data.subHeading : null]
    })

  }

  setPointvalidators(ctrl, key, value) {
    // controls
    const bannerCtrl = (<any>this[ctrl]).controls[key];
    const bannerValueCtrl = (<any>this[ctrl]).controls[value];

    // initialize value changes stream
    const bannerChanges$ = bannerCtrl.valueChanges;
    bannerChanges$.subscribe(buttonType => {
      if (buttonType == 'External URL') {
        bannerValueCtrl.setValidators([Validators.required, Validators.pattern(this.validationService.webUrl_regexPattern)]);
        bannerValueCtrl.updateValueAndValidity();
      } else {
        bannerValueCtrl.patchValue(null, { emitEvent: false });
        bannerValueCtrl.setValidators(null);
        bannerValueCtrl.updateValueAndValidity();
      }
    })
  }

  initDefaultBannerForm(data?, langType?, buttonType?) {
    if (langType == 'en' || langType == 1) {
      this.defaultBannerEn = this.initBannerForm(data ? data : null, 'default', 1, buttonType ? buttonType : 'Book Now');
      this.setPointvalidators('defaultBannerEn', 'buttonActionType', 'externalUrl');
      this.defaultBannerEn.valueChanges.subscribe(data => {
        if (this.defaultBannerEn.dirty) {
          this.isDirtyEn = true;
          console.log("en dirty " + this.isDirtyEn);
        }
        else {
          this.isDirtyEn = false;
        }
      });
    }

    if (langType == 'es' || langType == 2) {
      this.defaultBannerEs = this.initBannerForm(data ? data : null, 'default', 2, buttonType ? buttonType : 'Book Now');
      this.setPointvalidators('defaultBannerEs', 'buttonActionType', 'externalUrl');
      this.defaultBannerEs.valueChanges.subscribe(data => {
        if (this.defaultBannerEs.dirty) {
          this.isDirtyEs = true;
          console.log("es dirty " + this.isDirtyEs);
        }
        else {
          this.isDirtyEs = false;
        }
      });
    }
  }

  initDefaultBannerNonMemberForm(data?, langType?, buttonType?) {
    if (langType == 'en' || langType == 1) {
      this.defaultBannerNonMemberEn = this.initBannerForm(data ? data : null, 'default non-member', 1, buttonType ? buttonType : 'Register');
      this.setPointvalidators('defaultBannerNonMemberEn', 'buttonActionType', 'externalUrl');
      this.defaultBannerNonMemberEn.valueChanges.subscribe(data => {
        if (this.defaultBannerNonMemberEn.dirty) {
          this.isDirtyEn = true;
          console.log("en dirty " + this.isDirtyEn);
        }
        else {
          this.isDirtyEn = false;
        }
      });
    }
    if (langType == 'es' || langType == 2) {
      this.defaultBannerNonMemberEs = this.initBannerForm(data ? data : null, 'default non-member', 2, buttonType ? buttonType : 'Register');
      this.setPointvalidators('defaultBannerNonMemberEs', 'buttonActionType', 'externalUrl');
      this.defaultBannerNonMemberEs.valueChanges.subscribe(data => {
        if (this.defaultBannerNonMemberEs.dirty) {
          this.isDirtyEs = true;
          console.log("es dirty " + this.isDirtyEs);
        }
        else {
          this.isDirtyEs = false;
        }
      });
    }
  }

  initUpcomingBannerForm(data?, langType?, buttonType?) {
    if (langType == 'en' || langType == 1) {
      this.upcomingBannerEn = this.initBannerForm(data ? data : null, 'upcoming', 1, buttonType ? buttonType : 'View Booking');
      this.setPointvalidators('upcomingBannerEn', 'buttonActionType', 'externalUrl');
      this.upcomingBannerEn.valueChanges.subscribe(data => {
        if (this.upcomingBannerEn.dirty) {
          this.isDirtyEn = true;
          console.log("en dirty " + this.isDirtyEn);
        }
        else {
          this.isDirtyEn = false;
        }
      });
    }
    if (langType == 'es' || langType == 2) {
      this.upcomingBannerEs = this.initBannerForm(data ? data : null, 'upcoming', 2, buttonType ? buttonType : 'View Booking');
      this.setPointvalidators('upcomingBannerEs', 'buttonActionType', 'externalUrl');
      this.upcomingBannerEs.valueChanges.subscribe(data => {
        if (this.upcomingBannerEs.dirty) {
          this.isDirtyEs = true;
          console.log("es dirty " + this.isDirtyEs);
        }
        else {
          this.isDirtyEs = false;
        }
      });
    }
  }

  initPastBannerForm(data?, langType?, buttonType?) {
    if (langType == 'en' || langType == 1) {
      this.pastBannerEn = this.initBannerForm(data ? data : null, 'past visit', 1, buttonType ? buttonType : 'Take Survey');
      this.setPointvalidators('pastBannerEn', 'buttonActionType', 'externalUrl');
      this.pastBannerEn.valueChanges.subscribe(data => {
        if (this.pastBannerEn.dirty) {
          this.isDirtyEn = true;
          console.log("en dirty " + this.isDirtyEn);
        }
        else {
          this.isDirtyEn = false;
        }
      });
    }
    if (langType == 'es' || langType == 2) {
      this.pastBannerEs = this.initBannerForm(data ? data : null, 'past visit', 2, buttonType ? buttonType : 'Take Survey');
      this.setPointvalidators('pastBannerEs', 'buttonActionType', 'externalUrl');
      this.pastBannerEs.valueChanges.subscribe(data => {
        if (this.pastBannerEs.dirty) {
          this.isDirtyEs = true;
          console.log("es dirty " + this.isDirtyEs);
        }
        else {
          this.isDirtyEs = false;
        }
      });
    }
  }

  initBirthdayBannerForm(data?, langType?, buttonType?) {
    if (langType == 'en' || langType == 1) {
      this.birthdayBannerEn = this.initBannerForm(data ? data : null, 'birthday', 1, buttonType ? buttonType : 'Member Points');
      this.setPointvalidators('birthdayBannerEn', 'buttonActionType', 'externalUrl');
      this.birthdayBannerEn.valueChanges.subscribe(data => {
        if (this.birthdayBannerEn.dirty) {
          this.isDirtyEn = true;
          console.log("en dirty " + this.isDirtyEn);
        }
        else {
          this.isDirtyEn = false;
        }
      });
    }
    if (langType == 'es' || langType == 2) {
      this.birthdayBannerEs = this.initBannerForm(data ? data : null, 'birthday', 2, buttonType ? buttonType : 'Member Points');
      this.setPointvalidators('birthdayBannerEs', 'buttonActionType', 'externalUrl');
      this.birthdayBannerEn.valueChanges.subscribe(data => {
        if (this.birthdayBannerEn.dirty) {
          this.isDirtyEs = true;
          console.log("es dirty " + this.isDirtyEs);
        }
        else {
          this.isDirtyEs = false;
        }
      });
    }
  }

  initForm() {
    this.initDefaultBannerForm(null, 'en');
    this.initDefaultBannerForm(null, 'es');
    this.initDefaultBannerNonMemberForm(null, 'en');
    this.initDefaultBannerNonMemberForm(null, 'es');
    this.initUpcomingBannerForm(null, 'en');
    this.initUpcomingBannerForm(null, 'es');
    this.initPastBannerForm(null, 'en');
    this.initPastBannerForm(null, 'es');
    this.initBirthdayBannerForm(null, 'en');
    this.initBirthdayBannerForm(null, 'es');

  }
  getEnglishTranslations() {
    this.getJsonService.getJSON("../assets/i18n/", "en.json")
      .subscribe(
      (res) => {
        this.english = res;
        console.log("English Translations: " + res);
      },
      (err) => console.error("English Translations" + err));

  }
  getSpanishTranslations() {
    this.getJsonService.getJSON("../assets/i18n/", "es.json")
      .subscribe(
      (res) => {
        this.spanish = res;
        console.log("Spanish Translations: " + res);
      },
      (err) => console.error("Spanish Translations" + err));
  }

  ngOnInit() {
    this.subscription = this.loyaltyService.brandState
      .subscribe((state: any) => {
        this.brand = state.brand;
        this.getHeroBannerData(this.brand.brandId);
      });
    this.initForm();
    this.getEnglishTranslations();
    this.getSpanishTranslations();
  }

  ngAfterViewInit() {
    this.brand = this.hotelManagementService.getSelectedBrand();
    this.getHeroBannerData(this.brand.brandId);
  }

  changeLanguage() {
    if (this.isDirtyEn == true) {
      this.stayOnPage("english");
    }
    else if (this.isDirtyEs == true) {
      this.stayOnPage("spanish");
    }
  }
  stayOnPage(language) {
    let title = "";
    let status = "";
    let message = "";
    let action1 = "";
    let action2 = "";
    if (language == "english") {
      title = this.english.MODAL.CONFIRM;
      status = this.english.MODAL.ACTIVE;
      message = this.english.MODAL.NOT_SAVED;
      action1 = this.english.MODAL.YES;
      action2 = this.english.MODAL.NO;
    }
    else {
      title = this.spanish.MODAL.CONFIRM;
      status = this.spanish.MODAL.ACTIVE;
      message = this.spanish.MODAL.NOT_SAVED;
      action1 = this.spanish.MODAL.YES;
      action2 = this.spanish.MODAL.NO;
    }

    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-hero-banner',
      title: title,
      status: status,
      message: message,
      action1: action1,
      action2: action2,
      action: '',
      style: 'active'
    }
  }


  deleteImage(form,language) {
    let title = "";
    let status = "";
    let message = "";
    let action1 = "";
    let action2 = "";
    if (language == "english") {
      title = this.english.MODAL.CONFIRM;
      status = this.english.MODAL.ACTIVE;
      message = this.english.MODAL.DELETE_IMAGE;
      action1 = this.english.MODAL.YES;
      action2 = this.english.MODAL.NO;
    }
    else {
      title = this.spanish.MODAL.CONFIRM;
      status = this.spanish.MODAL.ACTIVE;
      message = this.spanish.MODAL.DELETE_IMAGE;
      action1 = this.spanish.MODAL.YES;
      action2 = this.spanish.MODAL.NO;
    }
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-image',
      title: title,
      status: status,
      message: message,
      action1: action1,
      action2: action2,
      action: '',
      form: form,
      control: null,
      i: null,
      type2: null,
      imageType: null
    }
  }

  uploadImage(event: any, mode) {
    if (mode == "logo") {
      this.imageFile_logo = this.utilService.uploadImage(event);
      this.logoError = this.imageFile_logo.errorUpload;
      this.logoSizeError = this.imageFile_logo.fileSizeError;
      setTimeout(() => {
        this.logoError = false;
        this.logoSizeError = false;
      }, 1000);
      if (this.logoError) {
        this.imageFile_logo.imageUrl = "";
      }
    }

  }
  // cancel(language) {
  //   let title = "";
  //   let status = "";
  //   let message = "";
  //   let action1 = "";
  //   let action2 = "";
  //   if (language == "english") {
  //     title = this.english.MODAL.CONFIRM;
  //     status = this.english.MODAL.ACTIVE;
  //     message = this.english.MODAL.MESSAGE;
  //     action1 = this.english.MODAL.YES;
  //     action2 = this.english.MODAL.NO;
  //   }
  //   else {
  //     title = this.spanish.MODAL.CONFIRM;
  //     status = this.spanish.MODAL.ACTIVE;
  //     message = this.spanish.MODAL.MESSAGE;
  //     action1 = this.spanish.MODAL.YES;
  //     action2 = this.spanish.MODAL.NO;
  //   }
  //   this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
  //   this.statusModal.content.srcObject = {
  //     mode: 'custom',
  //     type: 'hca-wizard',
  //     title: title,
  //     status: status,
  //     message: message,
  //     action1: action1,
  //     action2: action2,
  //     action: '',
  //     style: 'active'
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/hca-loyalty-website/landing-page-hero-banner/landing-page-hero-banner.component.ts